import ProcurementDemandListHeader from "./ProcurementDemandListHeader";
import ProcurementDemandListTable from "./ProcurementDemandListTable";

export { ProcurementDemandListHeader, ProcurementDemandListTable };
